import React from 'react';
import cn from 'classnames';
import PT from 'prop-types';

const Tabs = ({ options, fieldProps: { onChange, value }, variant = 'simple', helperVariant }) => {
  const handleSelect = (item) => () => onChange(item);
  const isActive = ({id}) => id == value?.id;

  return (
    <div className={cn('tabs-field', `tabs-field_${variant}`, {[`tabs-field_${helperVariant}`]: helperVariant})}>
      <div className="tabs-field__carts-list">
        {options.map((item) => (
          <div
            key={item.id}
            className={cn('tabs-field__cart', { 'active-cart': isActive(item) })}
            onClick={handleSelect(item)}
            data-testid={`tabs-cart-${item.id}`}
          >
            <p className="tabs-field__title">
              {item.getIcon && <span className="tabs-field__icon">{item.getIcon(isActive(item))}</span>}
              {item.title}
            </p>
            <p className="tabs-field__description">{item.description}</p>
            {item.footer && <div className="tabs-field__footer">{item.footer}</div>}
          </div>
        ))}
      </div>
    </div>
  );
};

Tabs.propTypes = {
  options: PT.arrayOf(PT.object),
  fieldProps: PT.object,
  variant: PT.oneOf(['primary', 'simple']),
};

export default Tabs;
